import * as React from 'react';
import { useUnassignedTasks } from '../../state/context';

const Count = () => {
  const count = useUnassignedTasks().length;

  return (
    <div className="text-base font-bold bg-blue-500 text-white px-2 rounded-xl tracking-wide -mt-4 ml-2">{count}</div>
  );
};

export default Count;
